/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { Switch } from "@mui/material";

const ToggleUseCaption = (props) => {
    
    const {
        updateImageSettings,
        settings,
    } = props || {};
    
    const defaultUseCaption = settings?.options?.useCaption || false;
    const [useCaption, setUseCaption] = useState(defaultUseCaption);
    
    const onChangeSettingChecked = (event) => {
        const _settings = structuredClone(settings);
        const newOptions = structuredClone(_settings?.options || {});
        const checked = event.target.checked;
        setUseCaption(checked);
        newOptions.useCaption = checked;
        const newSettings = {
            ..._settings,
            options: newOptions
        };
        updateImageSettings(newSettings);
    };
    
    return (
        <>
            <div className='in-page-scale-methods-use-caption'>
                <div className='component-labelField'>Use caption from image:</div>
                <div className='component-box'>
                    <Switch
                        size='small'
                        checked={useCaption}
                        onChange={(event) => {
                            onChangeSettingChecked(event);
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default ToggleUseCaption;
